export default "__VITE_ASSET__WpSXIHpM__"